/**
 * @file toast.tsx
 * @module Global/toast
 * @description Exposes shared toast-notification helpers for displaying standardized success, error, warning, and information feedback.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.3.0
 */

import { toast } from "react-toastify";

export const success = (message: string) => {
  return toast.success(message, {
    position: "top-right",
    theme: "colored",
    autoClose: 5000,
  });
};
export const error = (message: string) => {
  return toast.error(message, {
    position: "top-right",
    theme: "colored",
    autoClose: 5000,
  });
};
export const warning = (message: string) => {
  return toast.warning(message, {
    position: "top-right",
    theme: "colored",
    autoClose: 5000,
    style: {
      color: "#000",
    },
  });
}

export const info = (message: string) => {
  return toast.info(message, {
    position: "top-right",
    theme: "colored",
    autoClose: 5000,
  });
};
